// For full API documentation, including code examples, visit http://wix.to/94BuAAs



export function productPage1_viewportEnter(event) {
	//Add your code for this event here: 
}